const PRIORITY_ID = Object.freeze({
  normativa: '93c7e7ea-befb-4abf-b90a-f8ca22e15757',
  tecnica: '93c7e7ea-befb-4abf-b90a-f8ca22e15758',
  institucional: '93c7e7ea-befb-4abf-b90a-f8ca22e15759',
});

const PRIORITY_NAME = Object.freeze({
  normativa: 'Normativa',
  tecnica: 'Técnica',
  institucional: 'Institucional',
});

export { PRIORITY_ID, PRIORITY_NAME };
